import { AdminSettingsResponse } from '../../../../../types';
import { convertArrayToObjectByKey } from '../../../../Tables/Settings/DTRRules/components/utils/convertArrayToObjectByKey';
import { isEmpty } from 'ramda';
import dayjs from 'dayjs';

export const groupName = 'travel-calculation';

export const converter = (data: AdminSettingsResponse) => {
  if (!isEmpty(data))
    return {
      ...data[0],
      settings: convertArrayToObjectByKey(
        data[0]?.settings.map((value) => ({
          ...value,
          key: value.key.replaceAll('.', '_')
        })),
        'key'
      )
    };

  return undefined;
};

export const createTimeString = (
  settingsArray: AdminSettingsResponse,
  currentKey: string
) => {
  const timeString =
    settingsArray[0]?.settings.find(({ key }) => key === currentKey)?.value ??
    '0:00';
  const [hours, minutes] = timeString.split(':');
  return dayjs().hour(Number(hours)).minute(Number(minutes));
};
